import { ActionReducer, ActionReducerMap, createSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromApp from './app.reducer';

export interface State {
  app: fromApp.State;
}

export const reducers: ActionReducerMap<State> = {
  app: fromApp.reducer
};

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [
  debug
] : [];

export const storeConfig = {
  metaReducers,
  runtimeChecks: {
    strictStateImmutability: true,
    strictActionImmutability: true,
  }
};

const appState = (state: State) => state.app;
export const getTextSize = createSelector(appState, state => state.textSize);
export const getDownloadContent = createSelector(appState, state => state.downloadContent);
export const getToken = createSelector(appState, state => state.token);
export const getDarkMode = createSelector(appState, state => state.darkMode);
export const getDownloadComplete = createSelector(appState, state => state.downloadComplete);
export const getDownloadProgress = createSelector(appState, state => state.downloadProgress);
export const getDownloadCount = createSelector(appState, state => state.downloadCount);
export const getOrganization = createSelector(appState, state => state.organization);
export const getOrganizationDetail = createSelector(appState, state => state.organizationDetail);
export const getDynamicContentUrl = createSelector(appState, state => state.dynamicContentUrl);
export const getIsInhouse = createSelector(appState, state => state.isInhouse);
export const getDisableFavorites = createSelector(appState, state => state.disableFavorites);
export const getDisableShare = createSelector(appState, state => state.disableShare);
export const channels = createSelector(appState, state => state.channels);
export const channelSelected = createSelector(appState, state => state.channelSelected);
export const channelsUnlocked = createSelector(appState, state => state.channelsUnlocked);
export const meta = createSelector(appState, state => state.meta);
export const userId = createSelector(appState, state => state.userId);
export const getSelectedName = createSelector(appState, state => state.selectedName);
export const getAcceptedEula = createSelector(appState, state => state.acceptedEula);
export const getFirstStart = createSelector(appState, state => state.isFirstStart);
export const getDoneActivities = createSelector(appState, state => state.doneActivities);
export const getAvatarXp = createSelector(appState, state => state.avatarXp);
export const getAvatarLevel = createSelector(appState, state => state.avatarLevel);
export const getVisititedLexiconIds = createSelector(appState, state => state.visitedLexiconIds);
export const getFinishAnimationShown = createSelector(appState, state => state.finishAnimationShown);
export const getChildren = createSelector(appState, state => state.children);
export const getSelectedChildId = createSelector(appState, state => state.selectedChildId);
